import { Info } from "lucide-react";

export const RvoNotice = ({ compact = false }: { compact?: boolean }) => (
  <div
    className={`flex items-start gap-2 rounded-lg border border-info/20 bg-info/5 text-info ${
      compact ? "px-3 py-2 text-xs" : "px-4 py-3 text-sm"
    }`}
  >
    <Info className="mt-0.5 h-4 w-4 shrink-0" />
    <p className="text-foreground/80">
      Gebaseerd op de laatst geïmporteerde officiële RVO-meldcodelijsten. Wij zijn niet de RVO.
      Controleer voor je aanvraag altijd de officiële informatie van RVO.
    </p>
  </div>
);
